import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";
import type UserShift from "./UserShift";

@Model()
class Roster extends ApplicationRecord {
  static jsonapiType = "rosters";

  @Attr() date: string;

  @Attr() endTime: string;

  @Attr() notes: string;

  @Attr() startTime: string;

  @BelongsTo() user: User;

  @HasMany() userShifts: UserShift[];
}

export default Roster;
